/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react';

import './footer.css';

const ASSETS = 'https://www.jornaldocomercio.com/v2/assets/imgs';
const JC = 'https://www.jornaldocomercio.com';

const MenuArrow: React.FC<{ open: boolean }> = ({ open }) => (
  <svg
    className={`jc-footer__menu-arrow${open ? ' jc-footer__menu-arrow--open' : ''}`}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0303 4.71967C20.3232 5.01256 20.3232 5.48744 20.0303 5.78033L12.5303 13.2803C12.2374 13.5732 11.7626 13.5732 11.4697 13.2803L3.96967 5.78033C3.67678 5.48744 3.67678 5.01256 3.96967 4.71967C4.26256 4.42678 4.73744 4.42678 5.03033 4.71967L12 11.6893L18.9697 4.71967C19.2626 4.42678 19.7374 4.42678 20.0303 4.71967ZM20.0303 10.7197C20.3232 11.0126 20.3232 11.4874 20.0303 11.7803L12.5303 19.2803C12.2374 19.5732 11.7626 19.5732 11.4697 19.2803L3.96967 11.7803C3.67678 11.4874 3.67678 11.0126 3.96967 10.7197C4.26256 10.4268 4.73744 10.4268 5.03033 10.7197L12 17.6893L18.9697 10.7197C19.2626 10.4268 19.7374 10.4268 20.0303 10.7197Z"
      fill="#ED702D"
    />
  </svg>
);

const ScrollTopIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
    className="jc-footer__scroll-top-icon"
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-4.75a.75.75 0 001.5 0V8.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0L6.2 9.74a.75.75 0 101.1 1.02l1.95-2.1v4.59z"
      clipRule="evenodd"
    />
  </svg>
);

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [openMenus, setOpenMenus] = useState({
    1: false,
    2: false,
    3: false,
  });

  const toggleMenu = (id: 1 | 2 | 3) => {
    setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const menuListClass = (id: 1 | 2 | 3) =>
    `jc-footer__menu-list${
      openMenus[id] ? ' jc-footer__menu-list--open' : ''
    }`;

  return (
    <footer className="jc-footer">
      <div className="jc-footer__intro">
        <div className="jc-footer__intro-inner">
          <div className="jc-footer__brand">
            <img
              src={`${ASSETS}/logo.png`}
              alt="Jornal do Comércio. O jornal da economia e negócios do RS. 93 anos."
              className="jc-footer__logo"
            />
            <div className="jc-footer__contact-row jc-footer__contact-row--address">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                className="jc-footer__contact-icon"
              >
                <path
                  fillRule="evenodd"
                  d="M9.69 18.933l.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 00.281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 103 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 002.273 1.765 11.842 11.842 0 00.976.544l.062.029.018.008.006.003zM10 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
                  clipRule="evenodd"
                />
              </svg>
              <p className="jc-footer__contact-text">
                Av. Ipiranga, 6681, Prédio 99A - Sala 401 - Partenon Porto
                Alegre - RS - CEP 90619-900
              </p>
            </div>
            <div className="jc-footer__contact-row">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                className="jc-footer__contact-icon"
              >
                <path
                  fillRule="evenodd"
                  d="M2 3.5A1.5 1.5 0 013.5 2h1.148a1.5 1.5 0 011.465 1.175l.716 3.223a1.5 1.5 0 01-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 006.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 011.767-1.052l3.223.716A1.5 1.5 0 0118 15.352V16.5a1.5 1.5 0 01-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 012.43 8.326 13.019 13.019 0 012 5V3.5z"
                  clipRule="evenodd"
                />
              </svg>
              <p className="jc-footer__contact-text">(51) 3213.1300</p>
            </div>
          </div>
          <img
            src={`${ASSETS}/mobile-phone.png`}
            className="jc-footer__phone-img"
            alt="Fique por dentro de tudo que rola no Brasil e no mundo"
          />
          <div className="jc-footer__app">
            <img
              src={`${ASSETS}/mobile-phone.png`}
              className="jc-footer__app-img-mobile"
              alt="Fique por dentro de tudo que rola no Brasil e no mundo"
            />
            <button type="button" className="jc-footer__app-title">
              Fique por dentro de tudo que rola no Brasil e no mundo
            </button>
            <p className="jc-footer__app-desc">
              Baixe o app do Jornal do Comércio no seu celular.
            </p>
            <div className="jc-footer__app-stores">
              <a
                href="https://play.google.com/store/apps/details?id=com.jcrs.flip"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={`${ASSETS}/google-play.png`}
                  alt="Jornal do Comércio na Google Play"
                />
              </a>
              <a
                href="https://apps.apple.com/br/app/jornal-do-com%C3%A9rcio/id1507771607?platform=iphone"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={`${ASSETS}/app-store.png`}
                  alt="Jornal do Comércio na Apple Store"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="jc-footer__main">
        <div className="jc-footer__main-inner">
          <button
            type="button"
            className="jc-footer__scroll-top jc-footer__scroll-top--mobile"
            onClick={scrollToTop}
          >
            <ScrollTopIcon />
            Voltar ao topo
          </button>

          <div className="jc-footer__menus">
            <div className="jc-footer__menu-column">
              <div className="jc-footer__menu-header">
                <MenuArrow open={openMenus[1]} />
                <button
                  type="button"
                  className="jc-footer__menu-toggle"
                  onClick={() => toggleMenu(1)}
                >
                  Jornal do comércio
                </button>
              </div>
              <ul id="footer-menu-1" className={menuListClass(1)}>
                <li className="footer-link">
                  <a href={JC}>Capa</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/ultimas-noticias`}>Últimas notícias</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/flip`}>Edição para folhear</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/flip`}>Edições anteriores</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/cadernos`}>Cadernos especiais</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/publicidade-legal`}>Publicidade legal</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/fale-conosco`}>Fale conosco</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/institucional`}>Institucional</a>
                </li>
                <li className="footer-link">
                  <a href="https://d.jornaldocomercio.com/loja">Assine</a>
                </li>
                <li className="footer-link">
                  <a href="https://d.jornaldocomercio.com/anuncie">Anuncie</a>
                </li>
              </ul>
            </div>

            <div className="jc-footer__menu-column">
              <div className="jc-footer__menu-header">
                <MenuArrow open={openMenus[2]} />
                <button
                  type="button"
                  className="jc-footer__menu-toggle"
                  onClick={() => toggleMenu(2)}
                >
                  Editoriais
                </button>
              </div>
              <ul id="footer-menu-2" className={menuListClass(2)}>
                <li className="footer-link">
                  <a href={`${JC}/economia`}>Economia</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/politica`}>Política</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/geral`}>Geral</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/internacional`}>Internacional</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/esportes`}>Esportes</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/cultura`}>Cultura</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/opiniao`}>Opinião</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/colunas`}>Colunas</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/cadernos`}>Cadernos</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/ge2/capa`}>GeraçãoE</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/jornal-cidades`}>Jornal Cidades</a>
                </li>
                <li className="footer-link">
                  <a href="https://www.marcasdequemdecide.com.br/">Marcas</a>
                </li>
              </ul>
            </div>

            <div className="jc-footer__menu-column">
              <div className="jc-footer__menu-header">
                <MenuArrow open={openMenus[3]} />
                <button
                  type="button"
                  className="jc-footer__menu-toggle"
                  onClick={() => toggleMenu(3)}
                >
                  Serviços
                </button>
              </div>
              <ul id="footer-menu-3" className={menuListClass(3)}>
                <li className="footer-link">
                  <a href={`${JC}/agenda-de-eventos`}>Agenda de eventos</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/indicadores`}>Indicadores</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/galeria-de-videos`}>Galeria de vídeos</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/tempo`}>Tempo</a>
                </li>
                <li className="footer-link">
                  <a href={`${JC}/newsletter`}>Newsletter</a>
                </li>
              </ul>
            </div>
          </div>

          <button
            type="button"
            className="jc-footer__scroll-top jc-footer__scroll-top--desktop"
            onClick={scrollToTop}
          >
            <ScrollTopIcon />
            Voltar ao topo
          </button>
        </div>
      </div>

      <div className="jc-footer__bottom">
        <div className="jc-footer__bottom-inner">
          <p className="jc-footer__copyright">
            {`© Copyright ${currentYear} Empresa Jornalística J.C. Jarros Ltda. `}
            <small>Todos os direitos reservados</small>
          </p>
          <ul className="jc-footer__social-list">
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/jornaldocomercio/"
                className="footer-social-icon"
              >
                <img
                  src={`${ASSETS}/facebook.svg`}
                  alt="Facebook Jornal do Comércio"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://x.com/JC_RS"
                className="footer-social-icon"
              >
                <img
                  src={`${ASSETS}/twitter.svg`}
                  alt="X Jornal do Comércio"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/jornaldocomercio/"
                className="footer-social-icon"
              >
                <img
                  src={`${ASSETS}/instagram.svg`}
                  alt="Instagram Jornal do Comércio"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.tiktok.com/@jornaldocomerciors/"
                className="footer-social-icon"
              >
                <img
                  src={`${ASSETS}/tiktok.svg`}
                  alt="TikTok Jornal do Comércio"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/company/jornaldocomercio/"
                className="footer-social-icon"
              >
                <img
                  src={`${ASSETS}/linkedin.svg`}
                  alt="LinkedIn Jornal do Comércio"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.youtube.com/@JornaldoComercioRS"
                className="footer-social-icon"
                title="Youtube Jornal do Comércio"
              >
                <img
                  src={`${ASSETS}/youtube.svg`}
                  alt="Youtube Jornal do Comércio"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://link.rgmark.com.br/jornaldocomercio"
                className="footer-social-icon"
                title="Redes Jornal do Comércio"
              >
                <img
                  src={`${ASSETS}/beacons.svg`}
                  alt="Redes Jornal do Comércio"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href={`${JC}/fale-conosco`}
                className="footer-social-icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M3 4a2 2 0 00-2 2v1.161l8.441 4.221a1.25 1.25 0 001.118 0L19 7.162V6a2 2 0 00-2-2H3z" />
                  <path d="M19 8.839l-7.77 3.885a2.75 2.75 0 01-2.46 0L1 8.839V14a2 2 0 002 2h14a2 2 0 002-2V8.839z" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
